module.exports = require("@cloudbase/adapter-wx_mp");